import ClearIcon from "@assets/images/Clear.svg";
import {
  Box,
  IconButton,
  OutlinedTextFieldProps,
  TextField
} from "@material-ui/core";
import { makeStyles } from "@saleor/macaw-ui";
import React, { FC, useEffect, useState } from "react";

const useStyles = makeStyles(
  () => ({
    root: {
      "& .MuiOutlinedInput-adornedEnd": {
        paddingRight: 0
      },
      "& .MuiIconButton-root": {
        border: 0
      }
    }
  }),
  { name: "InputSearch" }
);

interface InputSearchProps extends OutlinedTextFieldProps {
  value?: string;
  maxLength?: number;
  inputType?: "string" | "number";
  isReset?: boolean;
  disabled?: boolean;
  regex?: RegExp;
  onChangeProps?: (value: string) => void;
}
const InputSearch: FC<InputSearchProps> = ({
  value,
  maxLength = 30,
  inputType = "string",
  isReset,
  regex,
  disabled,
  onChangeProps,
  ...props
}) => {
  const classes = useStyles(props);
  const [keyword, setKeyword] = useState(value || "");

  useEffect(() => {
    if (onChangeProps) {
      onChangeProps(keyword);
    }
  }, [keyword]);

  useEffect(() => {
    if (isReset) {
      setKeyword("");
    }
  }, [isReset]);

  const handleChange = event => {
    let currentValue = "";
    if (inputType === "number") {
      currentValue = event.target.value.replace(/[^0-9]/g, "");
    } else {
      currentValue = regex
        ? event.target.value.replace(regex, "")
        : event.target.value;
    }

    if (!currentValue || currentValue?.length <= maxLength || !maxLength) {
      setKeyword(currentValue);
    }
  };

  return (
    <Box className={classes.root}>
      <TextField
        {...props}
        type="text"
        helperText={null}
        onChange={handleChange}
        value={keyword}
        disabled={disabled}
        InputProps={{
          endAdornment:
            keyword && !disabled ? (
              <IconButton
                aria-label="toggle search pi"
                onClick={() => setKeyword("")}
              >
                <img src={ClearIcon} alt="" />
              </IconButton>
            ) : null
        }}
        fullWidth={true}
        autoComplete="off"
      />
    </Box>
  );
};

export default InputSearch;
